import classnames from "classnames";
import PropTypes from "prop-types";
import styles from "./index.css";
import content from "app-content";

const DeleteButton = ({ className, disabled, deleteItem }) => (
  <button
    className={classnames(className, styles.deleteButton)}
    aria-label={content.saved_items_accessibility_delete}
    onClick={deleteItem}
    disabled={disabled}
  />
);

DeleteButton.propTypes = {
  deleteItem: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  className: PropTypes.string
};

export default DeleteButton;
